/*
 * File: ActionModule.jsx
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on February 4, 2022 at 4:30 PM
 * Copyright © 2022 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: June 5, 2025 at 12:30 AM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import React, { forwardRef, useEffect } from 'react';
import PropTypes from 'prop-types';

// Styles
import * as S from './ActionModule.styles';


/**
 * Component
 */

export const ActionModule = forwardRef(({
	className, center, fireAnimation, canFly, onClick, children, ...rest
}, ref) => {

	// Handle actions on component load
	useEffect(() => {}, []);

	// Handle click event
	const handleClick = (e) => {

		// Fire necessary animations
		if (fireAnimation && canFly) fireAnimation();

		// Fire click
		if (onClick) onClick(e);
	};

	// Render component
	return (
		<S.Wrapper
			ref={ref}
			className={className ? `animate ${className}` : 'animate'}
			onClick={handleClick}
			$center={center}
			{...rest}
		>
			{children}
		</S.Wrapper>
	);
});


/**
 * Configuration
 */

ActionModule.displayName = 'ActionModule';
ActionModule.propTypes = {
	className: PropTypes.string,
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
	center: PropTypes.bool,
	fireAnimation: PropTypes.func,
	onClick: PropTypes.func,
	canFly: PropTypes.bool
};
ActionModule.defaultProps = {
	className: null,
	children: null,
	center: false,
	fireAnimation: null,
	onClick: null,
	canFly: true
};
